import { BaseStateInterface } from './basestate.state';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { QuestionnaireCsrdConfigDto } from 'app/@types/dto/questionnaire-csrd-config-dto.model';
import { QuestionnaireCsrdConfigHttpService } from '@services/datasources/questionnaireCsrdConfig-http.service';
import { tap } from 'rxjs';

export interface QuestionnaireCsrdConfigModel extends BaseStateInterface {
    questionnaireConfig: QuestionnaireCsrdConfigDto | undefined;
}

// eslint-disable-next-line @typescript-eslint/no-namespace -- NGXS action grouping requires namespace for combined value+type semantics
export namespace QuestionnaireCsrdConfigAction {
    export class Activate {
        public static type = '[questionnaireCsrdConfig UI] Activate questionnaireConfig';
        public constructor(public orgId: string) {}
    }
}

@State<QuestionnaireCsrdConfigModel>({
    name: 'questionnaireCsrdConfig',
    defaults: {
        questionnaireConfig: undefined,
        isInit: false,
        isLoading: false,
        errors: [],
    },
})
@Injectable()
export class QuestionnaireCsrdConfigState {
    constructor(private questionnaireConfigService: QuestionnaireCsrdConfigHttpService) {}

    //----- store action -----//

    @Action(QuestionnaireCsrdConfigAction.Activate)
    activate(ctx: StateContext<QuestionnaireCsrdConfigModel>, action: QuestionnaireCsrdConfigAction.Activate) {
        // Avoid refetching lmao
        if (!ctx.getState().isInit) {
            return this.questionnaireConfigService.get(action.orgId).pipe(
                tap((config) => {
                    if (config) {
                        ctx.patchState({
                            questionnaireConfig: config,
                            isInit: true,
                            isLoading: false,
                            errors: undefined,
                        });
                    } else {
                        const errors = ctx.getState().errors;
                        errors.push('Cannot fetch the questionnaire config');
                        ctx.patchState({
                            questionnaireConfig: undefined,
                            isInit: true,
                            isLoading: false,
                            errors: errors,
                        });
                    }
                }),
            );
        }
        return;
    }

    @Selector([QuestionnaireCsrdConfigState])
    static getStaticConfig(state: QuestionnaireCsrdConfigModel) {
        return state.questionnaireConfig;
    }
}
